export default {"src":"/_next/static/media/dark-mode.c3659f2d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};